import Bar from './bar.component';
export default Bar;
